////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { last } from 'lodash'

/////////STYLED/////////
const NumberPageLabel = styled.label`
	display: flex;
	height: 32px;
	width: 32px;
	border-radius: 50%;
	justify-content: center;
	align-items: center;
	background-color: ${(props) => (props.isActive ? '#E5E5E5' : 'white')};
	cursor: pointer;
`
const NumberPageInput = styled.input`
	display: none;
	height: 32px;
	width: 32px;
	border-radius: 50%;
	justify-content: center;
	align-items: center;
	background-color: #e5e5e5;
`
/////////STYLED/////////

const FactoryPageSelected = ({ options, handleSwapPage, pageValue, register }) => {
	const lastOption = last(options) - 1
	const lastOptionStr = lastOption.toString()

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			{(pageValue === '0' || options.length < 3) && (
				<NumberPageLabel isActive={pageValue === '1'}>
					<NumberPageInput type="radio" name="tmpGoTo" ref={register} value={1} onClick={() => handleSwapPage(1)} />
					{2}
				</NumberPageLabel>
			)}
			{options.length > 2 && pageValue === lastOptionStr && (
				<NumberPageLabel isActive={false}>
					<NumberPageInput
						type="radio"
						name="tmpGoTo"
						ref={register}
						value={lastOption - 1}
						onClick={() => handleSwapPage(lastOption - 1)}
					/>
					{lastOptionStr}
				</NumberPageLabel>
			)}
			{pageValue !== '0' && pageValue !== lastOptionStr && options.length > 2 && (
				<NumberPageLabel isActive={true}>
					<NumberPageInput
						type="radio"
						name="tmpGoTo"
						ref={register}
						value={pageValue}
						onClick={() => handleSwapPage(options[pageValue])}
					/>
					{options[pageValue]}
				</NumberPageLabel>
			)}
		</>
	)
}

FactoryPageSelected.propTypes = {}

FactoryPageSelected.defaultPropTypes = {}

export default FactoryPageSelected
